import './TicketInfo.scss';
import React from "react";
import {Badge} from "react-bootstrap";

const TicketInfoComponent = ({ticket}) => {
    if (ticket === null)
        return <></>;
    let area = ticket.area;

    let getTicketInfo = () => {
        let description = null;
        if (ticket.description !== null)
            description = ticket.description;
        else if (area.full_description !== null)
            description = area.full_description;
        else if (ticket.society.description !== null)
            description = ticket.society.description;

        return <div className={"container p-2"}>
            <div className={"header"}>
                <h3>{ticket.name}</h3>
                <Badge bg={"success"} style={{
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column"
                }}>{ticket.price.toFixed(2)}€</Badge>
            </div>
            <div className={"description"}>
            <b className={"orange"}>{global.getNameTicketType(ticket.type)}</b><br/>
            <span>Categoria {ticket.ticket_residence_type.name}</span><br/>

            <Badge bg="dark">Valido dal {ticket.date_start_validity}</Badge>
            <Badge style={{marginLeft: 4}} bg="dark">Valido fino al {ticket.date_end_validity}</Badge><br/>
            <div className="mt-2" dangerouslySetInnerHTML={{__html: description}}/>
            </div>
        </div>
    }
    return (
        <div className="ticket-info-container">
            {getTicketInfo()}
        </div>
    );
};

export default TicketInfoComponent;
